import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useCookies } from "react-cookie";

const BeachesDetails = () => {
  const [cookies] = useCookies(["token", "user", "id"]);
  const [showModal, setShowModal] = useState(false);
  const [amount, setAmount] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone_no, setPhone] = useState("");
  const [selectedDestination, setSelectedDestination] = useState("");

  const user_id = cookies.id;

  const destinations = [
    {
      name: "Goa",
      img: "goa.jpg",
      desc: "India’s most popular beach destination famous for nightlife, water sports and golden sands.",
    },
    {
      name: "Andaman & Nicobar Islands",
      img: "andaman.jpg",
      desc: "Tropical paradise with crystal clear water, coral reefs and white sandy beaches.",
    },
    {
      name: "Lakshadweep",
      img: "lakshadweep.jpg",
      desc: "Exotic coral islands with turquoise lagoons and untouched natural beauty.",
    },
    {
      name: "Kerala",
      img: "kerala-beach.jpg",
      desc: "Palm-lined beaches like Kovalam and Varkala with serene sunset views.",
    },
    {
      name: "Karnataka",
      img: "karnataka-beach.jpg",
      desc: "Peaceful beaches of Gokarna and Murudeshwar with spiritual charm.",
    },
    {
      name: "Diu",
      img: "diu.jpg",
      desc: "A calm island with Portuguese heritage, clean beaches and relaxed vibes.",
    },
    {
      name: "Bali",
      img: "bali.jpg",
      desc: "World-famous island for luxury resorts, surfing, temples and tropical scenery.",
    },
    {
      name: "Thailand",
      img: "thailand.jpg",
      desc: "Popular for Phuket, Krabi and Phi Phi Islands with vibrant nightlife and island hopping.",
    },
  ];

  const handlePayment = async () => {
    if (!amount || !name || !email || !phone_no) {
      alert("Please fill in all fields.");
      return;
    }

    try {
      const res = await fetch(
        "https://www.api.aacoreholidaysresort.com/api/payment_details/create-order",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ amount: parseFloat(amount) }),
        },
      );

      const data = await res.json();

      const options = {
        key: "rzp_live_RAfef3cbQ27N9l",
        amount: data.amount,
        currency: data.currency,
        name: "Aacore Resorts And Hospitality Pvt. Ltd.",
        description: `${selectedDestination} Beach Booking`,
        order_id: data.orderId,
        handler: async function (response) {
          const verifyRes = await fetch(
            "https://www.api.aacoreholidaysresort.com/api/payment_details/verify-payment",
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
                amount: parseFloat(amount),
                name,
                email,
                phone_no,
                user_id,
              }),
            },
          );

          const verifyData = await verifyRes.json();
          if (verifyData.success) {
            alert("Payment successful 🎉");
            setShowModal(false);
          } else {
            alert("Payment failed ❌");
          }
        },
        prefill: { name, email, contact: phone_no },
        theme: { color: "#3399cc" },
      };

      new window.Razorpay(options).open();
    } catch (err) {
      alert("Payment initialization failed.");
    }
  };

  return (
    <div id="beachesdetails">
      <div
        className="beachesdetails-banner py-5"
        style={{ backgroundImage: "url(/assets/images/beach.jpg)" }}
      >
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb bg-transparent">
            <li className="breadcrumb-item text-light">
              <Link to="/" className="text-light">
                Home
              </Link>
            </li>
            <li className="breadcrumb-item text-light">
              <Link to="/travelthemes" className="text-light">
                Travel Theme
              </Link>
            </li>
            <li className="breadcrumb-item active text-light">Beaches</li>
          </ol>
        </nav>
      </div>

      <div className="container mt-5">
        <h1 className="text-center mb-4">Beach Destinations</h1>

        <div className="row">
          {destinations.map((place, index) => (
            <div className="col-md-4 mb-4" key={index}>
              <div className="card">
                <img
                  src={`/assets/images/${place.img}`}
                  className="card-img-top"
                  style={{ height: "250px", objectFit: "cover" }}
                  alt={place.name}
                />
                <div className="card-body">
                  <h5 className="card-title">{place.name}</h5>
                  <p className="card-text">{place.desc}</p>
                  <button
                    className="btn btn-primary"
                    onClick={() => {
                      setSelectedDestination(place.name);
                      setShowModal(true);
                    }}
                  >
                    Book Now
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {showModal && (
        <div
          className="modal fade show d-block"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5>Book {selectedDestination} Beach Tour</h5>
                <button
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <input
                  className="form-control mb-2"
                  placeholder="Amount"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                />
                <input
                  className="form-control mb-2"
                  placeholder="Name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
                <input
                  className="form-control mb-2"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <input
                  className="form-control mb-2"
                  placeholder="Phone"
                  value={phone_no}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Close
                </button>
                <button className="btn btn-primary" onClick={handlePayment}>
                  Pay Now
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BeachesDetails;
